import React, {
  forwardRef,
  Fragment,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Router, { useRouter } from 'next/router';

import debounce from 'lodash/debounce';

import { handleToastError, parseHtml } from 'helpers/index';
import {
  DEFAULT_DURATION,
  QUESTION_ANSWER,
  QUESTION_TYPE,
} from 'constants/constants';
import unitCourseApi from 'api/unitCourseApi';
import { useTest, useUnit } from 'hooks/units/index';
import useI18n from 'hooks/use-i18n';
import { fetchTestAsync1, submitTest } from 'store/units/index';
import { getSelectedCentre } from 'store/master';
import { getColor, getColorText, getThemeColor } from 'store/settings';
import {
  showToastError,
  showToastInfo,
  showToastSuccess,
  showToastWarning,
} from '@core/components/toastify/ToastTypes';
import ButtonAnswer from './ButtonAnswer';
import QuestionType from '../../QuestionType/QuestionType';
import Duration from './Duration';
import { X } from 'react-feather';
import { Modal } from 'react-bootstrap';
import { Alert, Button, Card } from 'reactstrap';
import classNames from 'classnames';
import styled from '@emotion/styled';
import { isIOS, isMobile } from 'react-device-detect';
import dayjs from 'dayjs';
import { timeExpired } from 'modules/Course/CourseDetail/optimizedDetailPage/lesson-access-modal';
import { FormProvider, useForm } from 'react-form';
import FreeTextMarking from '../ContentResult/ResultItem/manual-marking/free-text';
import FillInTheBlankMarking from '../ContentResult/ResultItem/manual-marking/fill-in-blank';
import FillInTheGapMarking from '../ContentResult/ResultItem/manual-marking/fill-in-the-gap';
import DragDropMarking from '../ContentResult/ResultItem/manual-marking/drag-drop';
import OrderingMarking from '../ContentResult/ResultItem/manual-marking/ordering';
import MultipleChoiceMarking from '../ContentResult/ResultItem/manual-marking/multiple-choice';
import AssignmentMarking from '../ContentResult/ResultItem/manual-marking/assignment';
import { IoAlarmSharp } from 'react-icons/io5';
import ThemeButton from 'components/AntdFormInputs/theme-button';

const P_TAG = styled.p`
  font-weight: 600;
  border-radius: 2px;
  background-color: #d8dbde;
  color: #4a4a4a;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    top: 50%;
    left: 7px;
    background-color: #cb6363;
    transform: translateY(-50%);
  }
`;

const ContentQuestion = forwardRef((props, ref) => {
  const {
    availablePosition,
    availablePositionArray,
    isShuffle,
    bookmarked,
    setBookmarked,
    toggleBookmark,
    durationDisable,
    setDurationDisable,
    setIsLoading,
    isLoading,
    isSync,
    setIsSync,
  } = props;
  const test = useTest();

  const form = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: {
      data: [],
      type: test?.question?.type,
    },
    shouldUnregister: false,
  });

  const syncPending = useRef(false);

  const dispatch = useDispatch();
  const { query } = useRouter();
  const unitSelected = useUnit();
  const selectedCentre = useSelector(getSelectedCentre);
  const themeStatus = useSelector(getThemeColor);
  const hasSubmittedRef = useRef(false);
  // const [isLoading, setIsLoading] = useState(false);
  const [durationStart, setDurationStart] = useState(
    localStorage.getItem('testStartTime') !== null &&
      localStorage.getItem('testStartTime') !== undefined &&
      localStorage.getItem('testStartTime') !== ''
      ? new Date(localStorage.getItem('testStartTime'))
      : new Date(),
  );

  const seconds =
    sessionStorage.getItem('testSeconds') !== null &&
    sessionStorage.getItem('testSeconds') !== undefined &&
    sessionStorage.getItem('testSeconds') !== ''
      ? sessionStorage.getItem('testSeconds')
      : null;

  // useEffect(() => {
  //   if (unitSelected?.time?.end) {
  //     const utcTime = unitSelected?.time?.end;
  //     const currentDate = dayjs();
  //     const givenDate = dayjs(utcTime);
  //     const isSame = givenDate.isSame(currentDate, 'day');

  //     if (!unitSelected?.config?.duration && isSame) {
  //       const checkTime = () => {
  //         const targetTime = dayjs(utcTime);
  //         const storeTime = targetTime.subtract(30, 'seconds');
  //         const currentTime = dayjs();

  //         if (currentTime.isSame(storeTime, 'second')) {
  //           sessionStorage.setItem('testSeconds', DEFAULT_DURATION);
  //           showToastInfo('You have 30 seconds left');
  //           setDurationStart(new Date());
  //         }

  //         if (
  //           currentTime.format('HH:mm') === targetTime.format('HH:mm') &&
  //           !hasSubmittedRef.current
  //         ) {
  //           hasSubmittedRef.current = true;
  //           handleSubmit({
  //             autoSubmit: true,
  //           });
  //         }
  //       };

  //       const interval = setInterval(checkTime, 1000);

  //       return () => clearInterval(interval);
  //     }
  //   }
  // }, [unitSelected, isLoading, seconds]);

  const i18n = useI18n();

  const [list, setList] = useState([]);
  const [multi, setMulti] = useState();

  const [reviewModal, setReviewModal] = useState(false);
  const [allQuestion, setAllQuestion] = useState();
  const [finalAnswer, setFinalAnswer] = useState();

  const currentIndex = availablePositionArray?.findIndex(
    (value) => value === parseInt(test?.current),
  );

  const nextQuestionValue = availablePositionArray[currentIndex + 1];

  const previousQuestionValue = availablePositionArray[currentIndex - 1];

  const isFirstValue = isShuffle
    ? availablePositionArray[0]
    : availablePositionArray[0];

  const isLastValue = isShuffle
    ? availablePositionArray[availablePositionArray.length - 1]
    : availablePositionArray[availablePositionArray.length - 1];

  //color theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const Stylescal = styled.div`
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      border-color: ${colorStatus} !important;
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
    }
    .btn-danger:disabled {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
  `;

  const DivTag = styled.div`
    margin-top: 10px;
    word-break: break-all;
    & img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  `;
  const question = test?.question;
  const type = test?.question?.type;

  const grandchildFunction = (config) => {
    handleSubmit(config);
  };

  useImperativeHandle(ref, () => ({
    grandchildFunction,
  }));

  async function onSubmit(data, config, isDraft) {
    const isSkip = config?.isSkip || false;
    const isNext = config?.isNext || false;
    const autoSubmit = config?.autoSubmit || false;
    let body;
    if (test?.userQuestion?.result) {
      body = {
        data,
        id: question?._id,
        userQuestion: test?.userQuestion?._id,
      };
    } else {
      body = {
        data,
        id: question?._id,
      };
    }
    if (isDraft) {
      body.status = 'DRAFT';
    }

    const params = {
      id: unitSelected?._id,
      question: question?._id,
      ...(question?.questionLink && { questionLink: question?.questionLink }),
      ...(isSkip && { isSkip }),
      ...(autoSubmit && { autoSubmit, isDurationEnd: true }),
      ...(isShuffle &&
        (unitSelected?.status == 'RESET' ||
          unitSelected?.status == 'RESUBMIT' ||
          unitSelected?.reAttempt) && {
          shuffle: true,
        }),
      ...((unitSelected?.reAttempt ||
        unitSelected?.status == 'RESUBMIT' ||
        unitSelected?.status == 'RESET') && {
        shuffle: true,
      }),
    };

    if (config?.syncQuiz) {
      params.syncQuiz = true;
    }

    if (isLastValue !== parseInt(test?.current)) {
      params.next = isDraft ? parseInt(test?.current) : nextQuestionValue;
    }

    if (config?.isPrevious) {
      params.next = previousQuestionValue;
    }

    if (config?.isRandom) {
      params.next = config?.questionNumber;
    }

    if (config?.hasOwnProperty('isEmpty')) {
      body.isEmpty = config?.isEmpty;
    }

    if (isSkip) {
      params.next = isNext ? nextQuestionValue : parseInt(test?.current) - 1;
    }

    let param = {};
    if (selectedCentre?._id) {
      param.centreId = selectedCentre?._id;
    }
    if (
      selectedCentre?.reviewContent ||
      selectedCentre?.reviewContent === undefined
    ) {
      param.reviewContent = true;
    }

    let message = unitSelected?.config?.duration
      ? 'The quiz duration has ended '
      : "Time's up!";

    if (autoSubmit && !config?.isSubmit) {
      timeExpired(
        'Your answers has been submitted',
        {
          confirmButtonColor: themeStatus,
        },
        message,
      );
    }

    if (
      !config?.isPrevious &&
      !config?.isRandom &&
      (isLastValue == parseInt(test?.current) || autoSubmit) &&
      unitSelected?.time?.due &&
      unitSelected?.config?.detuction?.status
    ) {
      if (unitSelected?.time?.due) {
        const utcTime = unitSelected?.time?.due;
        const currentDate = dayjs();
        const givenDate = dayjs(utcTime);

        if (currentDate.isAfter(givenDate)) {
          const diffInDays = currentDate.diff(givenDate, 'day');
          const diffInHours = currentDate.diff(givenDate, 'hour');
          body.isDelay = true;
          body.hours = diffInHours;
          body.days = diffInDays;
        }
      }
    }

    await dispatch(
      submitTest(
        params,
        body,
        unitSelected?._id,
        query?.slug,
        parseInt(test?.current),
        param,
      ),
    );
    setIsLoading(false);
    setDurationDisable(false);
    setFinalAnswer();
  }

  async function submitFreetext(config, mode, isDraft) {
    if (isDraft) {
      const data = finalAnswer
        ? finalAnswer
        : document.getElementById('freeText')?.value;
      await onSubmit(data, config, true);
      showToastSuccess('Question saved in draft successfully');
    } else {
      if (mode == 'review' || config?.status === 'review') {
        const data = finalAnswer
          ? finalAnswer
          : document.getElementById('freeText')?.value;
        setFinalAnswer(data);
        if (!data && !config?.status) {
          throw 'EMPTY_ANSWER';
        } else {
          setReviewModal(true);
        }
      } else {
        const data = finalAnswer
          ? finalAnswer
          : document.getElementById('freeText')?.value;
        if (
          config?.isSkip ||
          config?.autoSubmit ||
          config?.isPrevious ||
          config?.isRandom
        ) {
          config.isEmpty = !data ? true : false;
          return await onSubmit(data, config);
        }

        if (!data) {
          throw 'EMPTY_ANSWER';
        }

        await onSubmit(data, config);
      }
    }
  }

  async function submitMTC(config, mode, isNext, isDraft) {
    if (isDraft) {
      const data = finalAnswer
        ? finalAnswer
        : question?.answers?.map((answer, index) => {
            return document.getElementById(`MTP-${index}`)?.checked;
          });
      await onSubmit(data, config, true);
      showToastSuccess('Save Draft successfully!');
    } else {
      if (mode == 'review' || config?.status === 'review') {
        const data = question?.answers?.map((answer, index) => {
          return document.getElementById(`MTP-${index}`)?.checked;
        });
        setFinalAnswer(data);
        if (data?.findIndex((answer) => answer) === -1 && !config?.status) {
          throw 'EMPTY_ANSWER';
        } else {
          setReviewModal(true);
        }
      } else {
        const data = finalAnswer
          ? finalAnswer
          : question?.answers?.map((answer, index) => {
              return document.getElementById(`MTP-${index}`)?.checked;
            });

        if (
          config?.isSkip ||
          config?.autoSubmit ||
          config?.isPrevious ||
          config?.isRandom
        ) {
          config.isEmpty =
            data?.findIndex((answer) => answer) === -1 ? true : false;

          return await onSubmit(data, config);
        }

        if (data?.findIndex((answer) => answer) === -1) {
          throw 'EMPTY_ANSWER';
        }

        await onSubmit(data, config);
      }
    }
  }

  async function submitFillTheGap(config, mode, isDraft) {
    if (isDraft) {
      const data = finalAnswer
        ? finalAnswer
        : [...document.getElementsByTagName('select')]?.map(
            (answer) => answer?.options[answer.selectedIndex].text,
          );
      await onSubmit(data, config, true);
      showToastSuccess('Save Draft successfully!');
    } else {
      if (mode == 'review' || config?.status === 'review') {
        const data = finalAnswer
          ? finalAnswer
          : [...document.getElementsByTagName('select')]?.map(
              (answer) => answer?.options[answer.selectedIndex].text,
            );
        setFinalAnswer(data);
        if (data.includes('-') && !config?.status) {
          throw 'EMPTY_ANSWER';
        } else {
          setReviewModal(true);
        }
      } else {
        const data = finalAnswer
          ? finalAnswer
          : [...document.getElementsByTagName('select')]?.map(
              (answer) => answer?.options[answer.selectedIndex].text,
            );

        if (
          config?.isSkip ||
          config?.autoSubmit ||
          config?.isPrevious ||
          config?.isRandom
        ) {
          config.isEmpty = data.includes('-') ? true : false;

          return await onSubmit(data, config);
        }

        if (data.includes('-')) {
          throw 'EMPTY_ANSWER';
        }

        await onSubmit(data, config);
      }
    }
  }

  async function submitFillTheBlank(config, mode, isNext, isDraft) {
    if (isDraft) {
      const data = [...document.getElementsByName('blank')]?.map((item) =>
        item.value.toLowerCase(),
      );
      await onSubmit(data, config, true);
      showToastSuccess('Save Draft successfully!');
    } else {
      if (mode == 'review' || config?.status === 'review') {
        const data = [...document.getElementsByName('blank')]?.map((item) =>
          item.value.toLowerCase(),
        );
        setFinalAnswer(data);
        if (data.includes('') && !config?.status) {
          throw 'EMPTY_ANSWER';
        } else {
          setReviewModal(true);
        }
      } else {
        const data = finalAnswer
          ? finalAnswer
          : [...document.getElementsByName('blank')]?.map((item) =>
              item.value.toLowerCase(),
            );

        if (
          config?.isSkip ||
          config?.autoSubmit ||
          config?.isPrevious ||
          config?.isRandom
        ) {
          config.isEmpty = data.includes('') ? true : false;
          return await onSubmit(data, config);
        }

        if (data.includes('')) {
          throw 'EMPTY_ANSWER';
        }
        await onSubmit(data, config);
      }
    }
  }
  async function submitOrderingAnDnD(config, mode, isDraft) {
    if (isDraft) {
      const order = list?.map((answer) => answer.content);
      await onSubmit(order, config, true);
      showToastSuccess('Save Draft successfully!');
    } else {
      if (mode == 'review' || config?.status === 'review') {
        const order = list?.map((answer) => answer.content);
        setFinalAnswer(order);
        setReviewModal(true);
      } else {
        const order = finalAnswer
          ? finalAnswer
          : list?.map((answer) => answer.content);
        let newOrder = JSON.parse(sessionStorage.getItem('ordering'))?.map(
          (answer) => answer.content,
        );
        await onSubmit(order?.length ? order : newOrder, config);
      }
    }
  }

  async function submitAssignment(config, mode, isDraft) {
    const LearnerAnswer = form.getValues('data');
    if (isDraft) {
      await onSubmit(LearnerAnswer, config, true);
      showToastSuccess('Save Draft successfully!');
    } else {
      if (mode == 'review' || config?.status === 'review') {
        setReviewModal(true);
      } else {
        await onSubmit(LearnerAnswer, config);
      }
    }
  }

  const cancelHandler = (value) => {
    setIsLoading(value);
    setReviewModal(value);
  };

  useEffect(async () => {
    if (reviewModal) {
      const res = await unitCourseApi.getAllQuestion(unitSelected?._id);
      let orderToIndexMap = {};
      res.forEach((item, index) => {
        orderToIndexMap[item.order] = index;
      });

      // Sort the res array based on the availablePosition array
      let sortedResponse = availablePositionArray.map(
        (position) => res[orderToIndexMap[position]],
      );
      setAllQuestion(sortedResponse);
    }

    return () => setAllQuestion([]);
  }, [reviewModal]);

  const debouncedFreeText = debounce(async () => {
    try {
      const data = {
        questionNumber: test?.current,
        isRandom: true,
        syncQuiz: true,
      };

      if (isSync) {
        syncPending.current = true;
        return;
      }

      setIsSync(true);
      await submitFreetext(data);

      if (syncPending.current) {
        syncPending.current = false;
       await debouncedFreeText();
      }
    } catch (e) {
      handleToastError(e, i18n);
    } finally {
      setIsSync(false);
    }
  }, 1000);

  async function handleSubmit(config, mode) {
    try {
      debouncedFreeText.cancel();
      if (isSync) return null;
      if (!config?.autoSubmit) {
        setIsLoading(true);
        setMulti();
      }
      if (parseInt(test?.current) == isLastValue) {
        clearInterval(props.setIntervalId);
        for (var i = 0; i < 1000; i++) {
          window.clearInterval(i);
        }
      }
      switch (type) {
        case QUESTION_TYPE.MTC:
          return await submitMTC(config, mode);
        case QUESTION_TYPE.FILLTHEGAP:
          return await submitFillTheGap(config, mode);
        case QUESTION_TYPE.FILLINTHEBLANK:
          return await submitFillTheBlank(config, mode);
        case QUESTION_TYPE.ORDERING:
        case QUESTION_TYPE.DRAGDROP:
          return await submitOrderingAnDnD(config, mode);
        case QUESTION_TYPE.FREETEXT:
          return await submitFreetext(config, mode);
        case QUESTION_TYPE.ASSIGNMENT:
          return await submitAssignment(config, mode);
        default:
          return null;
      }
    } catch (e) {
      if (e === 'EMPTY_ANSWER') {
        showToastError('Please enter the answer');
      } else {
        handleToastError(e, i18n);
      }
    } finally {
      setIsLoading(false);
    }
  }

  const previousQuestion = async (test) => {
    setIsLoading(true);
    setFinalAnswer();
    let previousValue = isShuffle
      ? availablePositionArray[
          availablePositionArray.findIndex((value) => value == test?.current) -
            1
        ]
      : parseInt(test?.current) - 1;
    await dispatch(
      fetchTestAsync1(
        unitSelected?._id,
        previousValue,
        isShuffle &&
          (unitSelected?.status == 'RESET' ||
            unitSelected?.status == 'RESUBMIT' ||
            unitSelected?.reAttempt),
        isShuffle &&
          (unitSelected?.status == 'RESET' ||
            unitSelected?.status == 'RESUBMIT' ||
            unitSelected?.reAttempt),
      ),
    );
    setIsLoading(false);
  };

  const renderAnswer = (resultData, currentTest) => {
    const isLastQuestion = currentTest;

    const getUserAnswer = () =>
      isLastQuestion
        ? finalAnswer
        : resultData?.resultAnswers || resultData?.result;

    if (!resultData) {
      return (
        <div className="">
          <P_TAG className="py-05 px-2  d-inline">Not Answered</P_TAG>
        </div>
      );
    }

    if (resultData?.type === QUESTION_TYPE.FREETEXT) {
      return (
        <div className="ml-2">
          <FreeTextMarking
            result={{
              ...resultData,
              dataContent: isLastQuestion
                ? finalAnswer
                : resultData?.dataContent,
            }}
          />
        </div>
      );
    }

    if (resultData?.type === QUESTION_TYPE.FILLINTHEBLANK) {
      return (
        <div className="ml-2">
          <span className="view-page-title my-1">Your Answer:</span>
          <FillInTheBlankMarking
            result={{
              ...resultData,
              modifiedContent: isLastQuestion
                ? finalAnswer
                : resultData?.modifiedContent,
            }}
          />
        </div>
      );
    }

    if (resultData?.type === QUESTION_TYPE.FILLTHEGAP) {
      return (
        <div className="freetext-correct-ans-align ml-2">
          <div className="mb-1">
            <span className="view-page-title">Your Answer:</span>
          </div>
          <Alert className="mt-1 show">
            <FillInTheGapMarking
              result={{
                ...resultData,
                modifiedContent: isLastQuestion
                  ? finalAnswer
                  : resultData?.modifiedContent,
              }}
            />
          </Alert>
        </div>
      );
    }

    if (resultData?.type === QUESTION_TYPE.DRAGDROP) {
      return (
        <div className="freetext-correct-ans ml-2">
          <span className="view-page-title">Your Answer: </span>
          <Alert className="mt-1 show">
            <DragDropMarking
              asnwer={getUserAnswer()}
              question={resultData?.data}
            />
          </Alert>
        </div>
      );
    }

    if (resultData?.type === QUESTION_TYPE.ORDERING) {
      return (
        <div className="freetext-correct-ans ml-2">
          <span className="view-page-title">Your Answer: </span>
          <Alert className="mt-1 show">
            <OrderingMarking
              result={isLastQuestion ? finalAnswer : resultData?.result}
            />
          </Alert>
        </div>
      );
    }

    if (resultData?.type === QUESTION_TYPE.MTC) {
      let params = {};
      if (isLastQuestion) {
        params.resultAnswers = resultData?.data?.map((item, index) => ({
          ...item,
          correct: finalAnswer?.[index],
        }));
        params.result = finalAnswer;
      } else {
        params = getUserAnswer();
      }
      return (
        <div className="freetext-correct-ans-align ml-2">
          <div className="mb-1">
            <span className="view-page-title">Your Answer:</span>
          </div>
          <Alert className="mt-1 show">
            <MultipleChoiceMarking
              result={{
                ...resultData,
                ...params,
              }}
            />
          </Alert>
        </div>
      );
    }

    if (resultData.type === QUESTION_TYPE.ASSIGNMENT) {
      return (
        <AssignmentMarking
          data={{ ...resultData, resultAnswers: getUserAnswer() }}
        />
      );
    }
  };

  const formatQuestionNumber = (index) => `${index + 1})`;

  const renderQuestion = (resultData, index) => {
    if (
      [
        QUESTION_TYPE.FREETEXT,
        QUESTION_TYPE.MTC,
        QUESTION_TYPE.DRAGDROP,
        QUESTION_TYPE.ORDERING,
        QUESTION_TYPE.ASSIGNMENT,
      ].includes(resultData?.type)
    ) {
      return (
        <div className="d-flex">
          {formatQuestionNumber(index)}
          {parseHtml(
            resultData?.content ?? '',
            'fill-in-the-blank fill-overflow-image customconten_elecment w-100 ml-50',
          )}
        </div>
      );
    }

    if (resultData?.type === QUESTION_TYPE.FILLTHEGAP) {
      return (
        <div className="freetext-correct-ans">
          <div className="customconten_elecment d-flex fill-overflow-image">
            {formatQuestionNumber(index)}{' '}
            {parseHtml(resultData?.contentHTML ?? '', 'ml-50 w-100')}
          </div>
        </div>
      );
    }

    if (resultData?.type === QUESTION_TYPE.FILLINTHEBLANK) {
      return (
        <div className="freetext-correct-ans">
          <div className="d-flex customconten_elecment">
            {formatQuestionNumber(index)}{' '}
            {parseHtml(
              resultData?.contentHTML ?? '',
              'fill-in-the-blank pr-1 fill-overflow-image ml-50 w-100',
            )}
          </div>
        </div>
      );
    }
  };

  const htmlRender = (dt, i) => {
    const shouldRender = unitSelected?.reAttempt ? dt?.reAttempt : true;
    if (!shouldRender) return null;

    const type = dt?.question?.type;
    const isLastQuestion = allQuestion?.length - 1 === i;
    const questionContent = dt?.question?.content || dt?.question?.contentHTML;
    let answerList = '';
    let item = `<div class="d-flex fill-overflow-image w-100"> <section class="whiteSpaceNowrap">${dt.order} )</section> <section class="ml-1 ml-1 text-word-break w-100">${questionContent}</section> </div>`;

    const formatAnswer = (answers) =>
      Array.isArray(answers) ? answers.join('') : answers;

    const getUserAnswers = () => {
      if (isLastQuestion) return finalAnswer;
      return dt?.userQuestion?.result || dt?.userQuestion?.dataContent;
    };

    if (['ORDERING', 'DRAGDROP', 'FILLINTHEBLANK'].includes(type)) {
      answerList = `${item}<div>Your answer : ${formatAnswer(
        getUserAnswers(),
      )}</div>`;
    } else if (type === 'FREETEXT') {
      answerList = `${item}<div>Your answer : ${formatAnswer(
        getUserAnswers(),
      )}</div>`;
    } else if (type === 'MTC') {
      if (dt?.question?.typeAnswer === QUESTION_ANSWER.RADIO) {
        const selectedAnswer = isLastQuestion
          ? dt?.question?.data?.[finalAnswer?.findIndex(Boolean)]?.content
          : dt?.userQuestion?.resultAnswers?.find(
              (_, index) => dt?.userQuestion?.result?.[index],
            )?.content;
        answerList = `${item}<div>Your answer : ${selectedAnswer}</div>`;
      } else {
        const selectedAnswers = isLastQuestion
          ? dt?.question?.data
              ?.filter((_, index) => finalAnswer?.[index])
              ?.map((dt) => dt.content)
          : dt?.userQuestion?.result?.map(
              (res, index) =>
                res && dt?.userQuestion?.resultAnswers[index]?.content,
            );
        answerList = `${item}<div>Your answer : ${formatAnswer(
          selectedAnswers,
        )}</div>`;
      }
    } else {
      answerList = `${item}<div>Your answer : ${formatAnswer(
        getUserAnswers(),
      )}</div>`;
    }

    return (
      <div>
        {parseHtml(
          answerList,
          test?.question?.type === 'FILLTHEGAP'
            ? 'reviewfillinthegap'
            : 'fill-in-the-blank',
        )}
      </div>
    );
  };
  return (
    <>
      <Modal size="lg" show={reviewModal}>
        <Modal.Header>
          <h3>Preview</h3>
          <span color="secondary" outline onClick={() => cancelHandler(false)}>
            <X />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div>
            {allQuestion?.length &&
              allQuestion?.map((dt, index) => (
                <Fragment key={dt?._id}>
                  <div className="my-2 m-1 foo quiz-weight">
                    <strong className="view-page-title">Question:</strong>
                    {renderQuestion(dt?.question, index)}
                  </div>

                  <div className="my-2 m-1 foo quiz-weight">
                    {dt?.question?._id === test?.question?._id
                      ? renderAnswer(dt?.userQuestion ?? dt?.question, true)
                      : renderAnswer(dt?.userQuestion)}
                  </div>
                </Fragment>
              ))}

            <hr />
            <div style={{ textAlign: 'end' }}>
              <button
                className={classNames('btn')}
                onClick={() => cancelHandler(false)}
              >
                Cancel{' '}
              </button>
              <button
                className="btn-bg-color"
                onClick={() =>
                  handleSubmit({
                    autoSubmit: true,
                    isSubmit: true,
                  })
                }
                style={{
                  backgroundColor: `${colorStatus}`,
                  color: `${colorTextStatus}`,
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.borderColor = colorStatus;
                  e.target.style.color = colorStatus;
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = colorStatus;
                  e.target.style.color = colorTextStatus;
                }}
              >
                Submit{' '}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* <div className="row mb-2">
        {unitSelected?.config?.completion?.enableButton &&
        parseInt(test?.current) !== isFirstValue ? (
          <div className="col-4 col-md-2 col-sm-2">
            <Stylescal>
              <Button
                className="btn-danger quiz-previous-button round"
                disabled={isLoading}
                size="sm"
                onClick={() =>
                  handleSubmit({
                    isPrevious: true,
                  })
                }
                // onClick={() => previousQuestion(test)}
              >
                Previous
              </Button>
            </Stylescal>
          </div>
        ) : (
          <div className="col-4 col-md-2 col-sm-2"></div>
        )}
        <div className="col-4 col-md-8 col-sm-8"></div>
        {unitSelected?.config?.completion?.enableButton &&
          parseInt(test?.current) !== isLastValue && (
            <div className="col-4 col-md-2 col-sm-2">
              <Stylescal>
                <Button
                  disabled={
                    isLoading
                      ? true
                      : test?.userQuestion?.reAttempt ||
                        test?.userQuestion?.status === 'DRAFT'
                      ? !test?.userQuestion?.reAttempted
                      : !test?.userQuestion?.result
                  }
                  className="btn-danger quiz-next-button float-right round"
                  size="sm"
                  onClick={() => handleSubmit(test)}
                >
                  Next
                </Button>
              </Stylescal>
            </div>
          )}
        {unitSelected?.config?.completion?.preview == 'BEFORE' &&
          parseInt(test?.current) == isLastValue && (
            <div className="col-4 col-md-2 col-sm-2">
              <Stylescal>
                <Button
                  className="btn-danger quiz-next-button round"
                  size="sm"
                  onClick={() => handleSubmit('', 'review')}
                >
                  Review
                </Button>
              </Stylescal>
            </div>
          )}
      </div> */}

      <div className="row mb-2">
        <div className="col-12">
          {!durationDisable &&
            (unitSelected?.config?.duration > 0 || seconds) && (
              <Duration
                seconds={seconds}
                onSubmitTest={handleSubmit}
                startTime={durationStart}
                hasSubmittedRef={hasSubmittedRef}
                durationDisable={durationDisable}
                setDurationDisable={setDurationDisable}
              />
            )}
        </div>
        {/* {!durationDisable && showAlert && (
          <div className="d-flex justify-content-end align-items-start col-6 col-md-6 col-sm-6">
            <p
              style={{
                backgroundColor: 'rgba(196, 22, 28, .12)',
                fontWeight: 'bold',
                color: '#c4161c',
                padding: 5,
              }}
            >
              <span style={{ marginRight: 3 }}>
                <IoAlarmSharp size={25} />
              </span>
              {`You have ${
                unitSelected?.config?.alertDuration
                  ? Number(unitSelected?.config?.alertDuration)
                  : 2
              } minutes remaining to complete this`}
            </p>
          </div>
        )} */}
      </div>

      <div
        className={
          test?.question?.type === 'FILLTHEGAP'
            ? 'fillinthegapstyle fill-overflow-image w-100'
            : test?.question?.type === 'FILLINTHEBLANK'
            ? 'd-flex fill-overflow-image w-100 align-items-baseline'
            : 'd-flex fill-overflow-image w-100'
        }
      >
        <section>
          {availablePositionArray?.findIndex(
            (value) => value == test?.current,
          ) +
            1 +
            ')'}
        </section>
        <section
          className={
            type == 'FILLINTHEBLANK'
              ? 'ml-1 text-word-break fill-blank w-100'
              : 'ml-1 text-word-break w-100'
          }
        >
          {parseHtml(
            test?.userQuestion?.reAttempt &&
              !test?.userQuestion?.reAttempted &&
              test?.userQuestion?.status !== 'DRAFT'
              ? test?.question?.content
              : test?.modifiedContent
              ? test?.modifiedContent
              : test?.question?.content,
            `fill-in-the-blank  ${isMobile && isIOS ? 'mobile-ios' : ''}`,
          )}
        </section>
      </div>
      <div className="d-flex">
        <section style={{ opacity: 0 }}>
          {availablePositionArray?.findIndex(
            (value) => value == test?.current,
          ) +
            1 +
            ')'}
        </section>
        <section className="ml-1  flex-1 mt-50">
          <FormProvider {...form}>
            {test && (
              <>
                <QuestionType
                  list={list}
                  type={type}
                  setList={setList}
                  isLoading={isLoading}
                  isSync={isSync}
                  test={test}
                  setMulti={setMulti}
                  multi={multi}
                  handleOnchange={() => {
                    if (type === QUESTION_TYPE.FREETEXT) {
                      debouncedFreeText();
                    }
                  }}
                  // componentFooter={
                  //   unitSelected?.config?.completion?.preview == 'BEFORE' &&
                  //   parseInt(test?.current) == isLastValue ? null : (
                  //     <ButtonAnswer
                  //       isLoading={isLoading}
                  //       onSubmit={handleSubmit}
                  //       availablePosition={availablePositionArray}
                  //     />
                  //   )
                  // }
                  question={test?.question}
                />
                {/* {(unitSelected?.config?.duration > 0 || seconds) && (
                  <Duration
                    seconds={seconds}
                    onSubmitTest={handleSubmit}
                    startTime={durationStart}
                    hasSubmittedRef={hasSubmittedRef}
                  />
                )} */}
              </>
            )}
            <div className="rounded py-1 flexRow justify-space-between mt-2 align-items-center">
              <div className="d-flex align-items-center">
                {unitSelected?.config?.completion?.enableButton &&
                  availablePositionArray.length > 1 &&
                  parseInt(test?.current) !== isFirstValue && (
                    <>
                      <ThemeButton
                        onClick={() =>
                          handleSubmit({
                            isPrevious: true,
                          })
                        }
                        disabled={durationDisable || isLoading || isSync}
                        padding="7px 18px"
                        className="rounded-pill"
                        variant="secondary"
                      >
                        Previous
                      </ThemeButton>
                    </>
                  )}
              </div>

              <div className="d-flex align-items-center">
                {unitSelected?.config?.completion?.enableButton &&
                  availablePositionArray.length > 1 &&
                  parseInt(test?.current) !== isLastValue && (
                    <>
                      <ThemeButton
                        onClick={() => handleSubmit()}
                        disabled={durationDisable || isLoading || isSync}
                        padding="7px 18px"
                        className="rounded-pill"
                        variant="secondary"
                      >
                        Next
                      </ThemeButton>
                    </>
                  )}

                {/* {unitSelected?.config?.completion?.preview == 'BEFORE' &&
                  parseInt(test?.current) == isLastValue && (
                    <button
                      className="btn btn-light d-flex align-items-end round"
                      style={{
                        color: 'grey',
                        border: '1px solid grey',
                        backgroundColor: 'transparent',
                      }}
                      onClick={() => handleSubmit('', 'review')}
                    >
                      Review
                    </button>
                  )}

                {/* {unitSelected?.config?.completion?.preview == 'BEFORE' &&
                parseInt(test?.current) == isLastValue ? (
                  <button
                    className="btn btn-light d-flex align-items-end round"
                    style={{
                      color: 'grey',
                      border: '1px solid grey',
                      backgroundColor: 'transparent',
                    }}
                    onClick={() => handleSubmit('', 'review')}
                  >
                    Review
                  </button>
                ) : (
                  unitSelected?.config?.completion?.enableButton &&
                  parseInt(test?.current) !== isLastValue && (
                    <button
                      className="btn btn-light d-flex align-items-end round"
                      disabled={
                        isLoading
                          ? true
                          : test?.userQuestion?.reAttempt ||
                            test?.userQuestion?.status === 'DRAFT'
                          ? !test?.userQuestion?.reAttempted
                          : !test?.userQuestion?.result
                      }
                      style={{
                        color: 'grey',
                        border: '1px solid grey',
                        backgroundColor: 'transparent',
                      }}
                      onClick={() => handleSubmit(test)}
                    >
                      Next
                    </button>
                  )
                )} */}
              </div>
            </div>
            <ButtonAnswer
              isLoading={isLoading || isSync}
              onSubmit={handleSubmit}
              availablePosition={availablePositionArray}
              toggleBookmark={toggleBookmark}
              setBookmarked={setBookmarked}
              bookmarked={bookmarked}
              isLastValue={parseInt(test?.current) === isLastValue}
              durationDisable={durationDisable}
            />
          </FormProvider>
        </section>
      </div>
    </>
  );
});

export default ContentQuestion;
